import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchWorkFlows(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('operation/work-flows', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteWorkFlow(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`operation/work-flows/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    duplicateWorkFlow(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`operation/work-flows/${id}/duplicate`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
